import Icon from './Icon';

const TopEducators = (props) => (
  <Icon {...props} viewBox="0 0 180 60">
    <path
      d="M8 0C3.58172 0 0 3.58172 0 8V52C0 56.4183 3.58172 60 8 60H52C55.012 60 57.6353 58.3354 59 55.876C58.3628 54.7278 58 53.4062 58 52V8C58 6.59375 58.3628 5.27224 59 4.12399C57.6353 1.66458 55.012 0 52 0H8Z"
      fill="#A5BED3"
    />
    <mask
      id="mask0_3099_21241"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="59"
      height="60"
    >
      <path
        d="M8 0C3.58172 0 0 3.58172 0 8V52C0 56.4183 3.58172 60 8 60H52C55.012 60 57.6353 58.3354 59 55.876C58.3628 54.7278 58 53.4062 58 52V8C58 6.59375 58.3628 5.27224 59 4.12399C57.6353 1.66458 55.012 0 52 0H8Z"
        fill="#A5BED3"
      />
    </mask>
    <g mask="url(#mask0_3099_21241)">
      <rect
        x="19.7913"
        y="36.7837"
        width="15"
        height="7.5"
        rx="1"
        fill="#000A1B"
      />
      <path
        d="M15.7827 15.189C15.2503 9.33288 19.8613 4.28369 25.7416 4.28369H30.5764C36.2775 4.28369 40.8249 9.04257 40.5661 14.7378L40.1167 24.6242C39.9346 28.6298 36.6341 31.7837 32.6244 31.7837H24.1404C20.2613 31.7837 17.0224 28.8258 16.6712 24.9627L15.7827 15.189Z"
        fill="#0A1935"
      />
      <path
        d="M44.7776 46.2127L55.6169 61.6867L1.93771 61.6867L9.42205 47.6281C11.7902 43.1797 16.4189 40.4001 21.4584 40.4001L33.6093 40.4001C38.0573 40.4001 42.2257 42.5696 44.7776 46.2127Z"
        fill="#071733"
      />
      <path
        d="M32.3975 25.5519L33.6668 29.6003L31.0782 29.7208"
        stroke="black"
        strokeWidth="0.431902"
      />
      <path
        d="M34.423 16.6256L37.0926 24.2239C37.185 24.4869 37.1169 24.7795 36.9179 24.9747L35.2681 26.5925L33.1195 34.4261L33.5049 42.7099C33.5378 43.4165 33.1771 44.0834 32.5678 44.4428L32.0239 44.7635C29.266 46.3899 25.8763 46.5251 22.9977 45.1234L22.5661 44.9133C21.9383 44.6075 21.5275 43.9834 21.495 43.2858L20.583 23.6817L34.423 16.6256Z"
        fill="#F9B8A4"
      />
      <mask
        id="mask1_3099_21241"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="17"
        y="28"
        width="17"
        height="18"
      >
        <path
          d="M20.1607 28.7247L33.1038 34.1068L33.6526 45.9032L17.5531 34.2263L20.1607 28.7247Z"
          fill="#F9B8A4"
        />
      </mask>
      <g mask="url(#mask1_3099_21241)">
        <path
          d="M34.1515 40.1085C34.2478 39.5036 32.8261 37.1565 33.9833 36.4921L24.7485 35.5808C24.3067 35.5372 23.952 35.9428 24.0985 36.3618C26.117 42.136 34.0495 40.7499 34.1515 40.1085Z"
          fill="#DB8C74"
        />
      </g>
      <path
        d="M16.7928 24.8934C17.1362 32.2752 21.1198 38.4563 28.4547 38.4319C35.1921 38.4095 40.0169 31.2107 39.6735 23.829C31.0324 17.8503 38.9234 10.0275 28.7989 10.0612C17.3691 10.0992 24.784 16.6352 16.7928 24.8934Z"
        fill="#0A1935"
      />
      <path
        d="M16.8172 22.8861C17.1724 30.5226 21.1662 36.923 28.5016 36.9095C35.2395 36.8971 40.0531 29.4582 39.6978 21.8217C39.3426 14.1852 38.9256 7.54367 28.8004 7.56231C17.3698 7.58336 16.4619 15.2496 16.8172 22.8861Z"
        fill="#F9B8A4"
      />
      <path
        d="M17.8611 16.7759C16.4575 16.7617 15.5656 15.2681 16.2188 14.0257L19.1666 8.41872C20.1711 6.50797 22.8659 6.39722 24.0238 8.2191C24.7479 9.35839 24.5593 10.8516 23.5746 11.7751L18.5125 16.5221C18.3362 16.6874 18.1028 16.7784 17.8611 16.7759Z"
        fill="#0A1935"
      />
      <path
        d="M38.8929 15.3818C40.535 14.5474 40.7416 12.284 39.2777 11.1661L33.5396 6.78422L29.9944 5.4372C27.3524 4.4333 24.3781 5.57782 23.0905 8.09386C22.219 9.79664 22.9599 11.8818 24.7104 12.653L31.9302 15.8339C33.9889 16.741 36.346 16.676 38.3516 15.6568L38.8929 15.3818Z"
        fill="#0A1935"
      />
      <path
        d="M41.0089 24.4243C41.1516 23.3056 40.28 22.3157 39.1522 22.3157L17.1426 22.3157C16.0149 22.3157 15.1432 23.3056 15.286 24.4243L15.5586 26.5603C15.6778 27.4948 16.4731 28.195 17.4152 28.195L38.8796 28.195C39.8217 28.195 40.617 27.4948 40.7363 26.5603L41.0089 24.4243Z"
        fill="#F9B8A4"
      />
      <path
        d="M28.0234 23.8115L27.024 26.8533C26.827 27.4529 27.2559 28.0752 27.8864 28.1046L29.2538 28.1682"
        stroke="#DB8C74"
        strokeWidth="0.763514"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="transparent"
      />
      <path
        d="M19.6472 21.4872C19.2247 20.3732 21.2563 19.0697 23.2287 18.6901C23.9565 18.55 24.5869 19.0956 24.734 19.822C24.7774 20.0361 24.5993 20.2339 24.3811 20.244C22.5845 20.3274 19.7622 21.7904 19.6472 21.4872Z"
        fill="#081A3D"
      />
      <path
        d="M36.4872 21.0417C36.8756 19.9154 34.8054 18.6741 32.8223 18.3546C32.0906 18.2366 31.4771 18.8012 31.3521 19.5317C31.3153 19.747 31.4992 19.9392 31.7176 19.9427C33.516 19.9716 36.3814 21.3482 36.4872 21.0417Z"
        fill="#081A3D"
      />
      <path
        d="M18.3462 45.8512C17.3806 45.113 17.0857 43.7874 17.6475 42.7095L20.4642 37.3051C20.4928 37.2501 20.5716 37.2502 20.6002 37.3053L20.8536 37.7937C22.4385 40.8487 24.7562 43.4631 27.5991 45.4028C27.7153 45.482 27.7721 45.6234 27.7431 45.761L26.5854 51.2492C26.5096 51.6088 26.0846 51.7664 25.7926 51.5432L18.3462 45.8512Z"
        fill="#010E24"
      />
      <path
        d="M36.0296 45.8512C36.9952 45.113 37.29 43.7874 36.7283 42.7095L33.9148 37.3113C33.8847 37.2537 33.8023 37.2537 33.7723 37.3114L33.4486 37.9355C31.9099 40.9015 29.6906 43.4609 26.9723 45.4041C26.8616 45.4832 26.8063 45.6191 26.8303 45.7531L27.8092 51.2174C27.8752 51.5858 28.3077 51.7538 28.6051 51.5265L36.0296 45.8512Z"
        fill="#010E24"
      />
      <ellipse cx="23.2288" cy="24.2837" rx="0.9375" ry="1.25" fill="#0A1935" />
      <ellipse cx="33.2288" cy="24.2837" rx="0.9375" ry="1.25" fill="#0A1935" />
      <rect
        x="17.2913"
        y="21.7837"
        width="8.75"
        height="5"
        rx="0.5"
        stroke="white"
        fill="transparent"
      />
      <rect
        width="8.75"
        height="5"
        rx="0.5"
        transform="matrix(-1 0 0 1 38.5413 21.7837)"
        stroke="white"
        fill="transparent"
      />
      <path d="M26.0413 23.0337H29.7913" stroke="white" />
      <path
        d="M24.7913 29.2837H31.0413C31.0413 30.6644 29.922 31.7837 28.5413 31.7837H27.2913C25.9105 31.7837 24.7913 30.6644 24.7913 29.2837Z"
        fill="white"
      />
      <path
        d="M23.5413 30.5337L24.6448 29.4301C24.7386 29.3364 24.8658 29.2837 24.9984 29.2837H30.8342C30.9668 29.2837 31.0939 29.3364 31.1877 29.4301L32.2913 30.5337"
        stroke="#0A1935"
        strokeLinecap="round"
      />
      <path
        d="M27.2913 34.2837H28.5413"
        stroke="#0A1935"
        strokeLinecap="round"
      />
      <path
        d="M17.9163 50.8462C17.9163 51.0514 17.8759 51.2546 17.7974 51.4442C17.7188 51.6337 17.6037 51.806 17.4587 51.9511C17.3136 52.0962 17.1413 52.2113 16.9517 52.2898C16.7622 52.3683 16.559 52.4087 16.3538 52.4087C16.1486 52.4087 15.9454 52.3683 15.7558 52.2898C15.5663 52.2113 15.394 52.0962 15.2489 51.9511C15.1038 51.806 14.9887 51.6337 14.9102 51.4442C14.8317 51.2546 14.7913 51.0514 14.7913 50.8462L16.3538 50.8462H17.9163Z"
        fill="white"
      />
      <path
        d="M15.5725 53.5024C15.5725 53.3998 15.5928 53.2982 15.632 53.2035C15.6713 53.1087 15.7288 53.0225 15.8014 52.95C15.8739 52.8774 15.96 52.8199 16.0548 52.7806C16.1496 52.7414 16.2512 52.7212 16.3538 52.7212C16.4564 52.7212 16.558 52.7414 16.6528 52.7806C16.7476 52.8199 16.8337 52.8774 16.9062 52.95C16.9788 53.0225 17.0363 53.1087 17.0756 53.2035C17.1149 53.2982 17.1351 53.3998 17.1351 53.5024L16.3538 53.5024L15.5725 53.5024Z"
        fill="white"
      />
    </g>
    <path
      d="M68 0C63.5817 0 60 3.58172 60 8V52C60 56.4183 63.5817 60 68 60H112C115.012 60 117.635 58.3354 119 55.876C118.363 54.7278 118 53.4062 118 52V8C118 6.59375 118.363 5.27224 119 4.12399C117.635 1.66458 115.012 0 112 0H68Z"
      fill="#A5BED3"
    />
    <mask
      id="mask2_3099_21241"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="60"
      y="0"
      width="59"
      height="60"
    >
      <path
        d="M68 0C63.5817 0 60 3.58172 60 8V52C60 56.4183 63.5817 60 68 60H112C115.012 60 117.635 58.3354 119 55.876C118.363 54.7278 118 53.4062 118 52V8C118 6.59375 118.363 5.27224 119 4.12399C117.635 1.66458 115.012 0 112 0H68Z"
        fill="#A5BED3"
      />
    </mask>
    <g mask="url(#mask2_3099_21241)">
      <rect
        x="75.7513"
        y="4.43091"
        width="25"
        height="50"
        rx="12.5"
        fill="#010E24"
      />
      <rect
        x="80.7513"
        y="36.9309"
        width="15"
        height="7.5"
        rx="1"
        fill="#000A1B"
      />
      <path
        d="M105.738 46.3599L116.577 61.8339L62.8981 61.8339L70.3825 47.7753C72.7507 43.3269 77.3793 40.5474 82.4188 40.5474L94.5697 40.5474C99.0177 40.5474 103.186 42.7168 105.738 46.3599Z"
        fill="#071733"
      />
      <path
        d="M95.3834 16.7728L98.053 24.3711C98.1454 24.6341 98.0773 24.9268 97.8783 25.1219L96.2285 26.7397L94.0799 34.5733L94.4653 42.8571C94.4982 43.5637 94.1375 44.2306 93.5282 44.59L92.9843 44.9107C90.2264 46.5371 86.8367 46.6723 83.958 45.2706L83.5265 45.0605C82.8987 44.7548 82.4879 44.1306 82.4554 43.433L81.5434 23.829L95.3834 16.7728Z"
        fill="#F9B8A4"
      />
      <mask
        id="mask3_3099_21241"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="78"
        y="28"
        width="17"
        height="19"
      >
        <path
          d="M81.1211 28.8719L94.0642 34.254L94.613 46.0504L78.5135 34.3735L81.1211 28.8719Z"
          fill="#F9B8A4"
        />
      </mask>
      <g mask="url(#mask3_3099_21241)">
        <path
          d="M95.1119 40.2557C95.2081 39.6508 93.7865 37.3037 94.9436 36.6393L85.7088 35.728C85.267 35.6844 84.9123 36.09 85.0588 36.5091C87.0773 42.2832 95.0098 40.8972 95.1119 40.2557Z"
          fill="#DB8C74"
        />
      </g>
      <path
        d="M77.3077 23.0333C77.6629 30.6698 81.6568 37.0702 88.9921 37.0567C95.7301 37.0443 100.544 29.6054 100.188 21.9689C99.8331 14.3324 99.4161 7.69089 89.291 7.70953C77.8604 7.73058 76.9524 15.3969 77.3077 23.0333Z"
        fill="#F9B8A4"
      />
      <path
        d="M101.969 24.5715C102.112 23.4528 101.24 22.4629 100.113 22.4629L78.103 22.4629C76.9753 22.4629 76.1036 23.4528 76.2464 24.5715L76.519 26.7075C76.6382 27.642 77.4335 28.3422 78.3756 28.3422L99.84 28.3422C100.782 28.3422 101.577 27.642 101.697 26.7075L101.969 24.5715Z"
        fill="#F9B8A4"
      />
      <path
        d="M88.9837 23.9588L87.9843 27.0005C87.7873 27.6002 88.2162 28.2225 88.8467 28.2518L90.2142 28.3154"
        stroke="#DB8C74"
        strokeWidth="0.763514"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="transparent"
      />
      <path
        d="M80.4143 21.2226C80.1771 20.0551 82.3924 19.0964 84.4002 19.04C85.1411 19.0192 85.6752 19.6594 85.7031 20.4001C85.7114 20.6183 85.5038 20.7847 85.2868 20.7595C83.5003 20.552 80.4788 21.5404 80.4143 21.2226Z"
        fill="#010E24"
      />
      <path
        d="M96.7784 20.7334C96.963 19.5564 94.707 18.6979 92.6986 18.7316C91.9576 18.744 91.4527 19.4075 91.458 20.1486C91.4595 20.3671 91.6744 20.524 91.89 20.4891C93.6655 20.2017 96.7281 21.0537 96.7784 20.7334Z"
        fill="#010E24"
      />
      <path
        d="M95.7517 27.4307C95.3724 28.1944 93.9318 29.9497 91.2041 30.8615"
        stroke="#DB8C74"
        strokeWidth="0.763514"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M79.3065 45.9986C78.3409 45.2605 78.046 43.9348 78.6078 42.857L81.4245 37.4526C81.4532 37.3976 81.5319 37.3976 81.5605 37.4527L81.8139 37.9412C83.3988 40.9962 85.7165 43.6105 88.5595 45.5502C88.6756 45.6295 88.7324 45.7709 88.7034 45.9084L87.5458 51.3966C87.4699 51.7563 87.0449 51.9139 86.7529 51.6907L79.3065 45.9986Z"
        fill="#010E24"
      />
      <path
        d="M96.9899 45.9986C97.9555 45.2605 98.2503 43.9348 97.6886 42.857L94.8751 37.4588C94.8451 37.4011 94.7626 37.4012 94.7327 37.4589L94.4089 38.083C92.8702 41.049 90.6509 43.6083 87.9327 45.5515C87.8219 45.6307 87.7666 45.7666 87.7906 45.9006L88.7696 51.3649C88.8356 51.7333 89.268 51.9012 89.5654 51.6739L96.9899 45.9986Z"
        fill="#010E24"
      />
      <ellipse cx="83.6888" cy="24.4309" rx="0.9375" ry="1.25" fill="#0A1935" />
      <ellipse cx="93.6888" cy="24.4309" rx="0.9375" ry="1.25" fill="#0A1935" />
      <path
        d="M78.8764 50.9934C78.8764 51.1986 78.836 51.4018 78.7575 51.5914C78.6789 51.781 78.5638 51.9532 78.4187 52.0983C78.2736 52.2434 78.1014 52.3585 77.9118 52.437C77.7222 52.5155 77.5191 52.556 77.3139 52.556C77.1087 52.556 76.9055 52.5155 76.7159 52.437C76.5263 52.3585 76.3541 52.2434 76.209 52.0983C76.0639 51.9532 75.9488 51.781 75.8703 51.5914C75.7918 51.4018 75.7513 51.1986 75.7513 50.9934L77.3139 50.9934H78.8764Z"
        fill="white"
      />
      <path
        d="M76.5326 53.6496C76.5326 53.547 76.5528 53.4455 76.5921 53.3507C76.6313 53.2559 76.6889 53.1698 76.7614 53.0972C76.834 53.0247 76.9201 52.9671 77.0149 52.9279C77.1097 52.8886 77.2113 52.8684 77.3139 52.8684C77.4165 52.8684 77.5181 52.8886 77.6128 52.9279C77.7076 52.9671 77.7938 53.0247 77.8663 53.0972C77.9388 53.1698 77.9964 53.2559 78.0357 53.3507C78.0749 53.4455 78.0951 53.547 78.0951 53.6496L77.3139 53.6496L76.5326 53.6496Z"
        fill="white"
      />
      <path
        d="M75.7513 16.9309C75.7513 11.4081 80.2285 6.93091 85.7513 6.93091H88.2513V11.9309C88.2513 14.6923 86.0128 16.9309 83.2513 16.9309H75.7513Z"
        fill="#010E24"
      />
      <path
        d="M100.751 16.9309C100.751 11.4081 96.2742 6.93091 90.7513 6.93091H88.2513V11.9309C88.2513 14.6923 90.4899 16.9309 93.2513 16.9309H100.751Z"
        fill="#010E24"
      />
      <path
        d="M77.0013 16.9309H79.5013V23.6584C79.5013 24.085 79.1555 24.4309 78.7288 24.4309C78.4362 24.4309 78.1687 24.2656 78.0378 24.0039L77.0013 21.9309V16.9309Z"
        fill="#010E24"
      />
      <path
        d="M100.751 16.9309H98.2513V23.6584C98.2513 24.085 98.5972 24.4309 99.0239 24.4309C99.3165 24.4309 99.584 24.2656 99.7149 24.0039L100.751 21.9309V16.9309Z"
        fill="#010E24"
      />
    </g>
    <rect x="120" width="60" height="60" rx="8" fill="#A5BED3" />
    <mask
      id="mask4_3099_21241"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="120"
      y="0"
      width="60"
      height="60"
    >
      <rect x="120" width="60" height="60" rx="8" fill="#A5BED3" />
    </mask>
    <g mask="url(#mask4_3099_21241)">
      <rect
        x="142.158"
        y="37.231"
        width="15"
        height="7.5"
        rx="1"
        fill="#000A1B"
      />
      <path
        d="M167.144 46.6599L177.983 62.134L124.304 62.134L131.789 48.0754C134.157 43.627 138.785 40.8474 143.825 40.8474L155.976 40.8474C160.424 40.8474 164.592 43.0169 167.144 46.6599Z"
        fill="#071733"
      />
      <path
        d="M138.148 15.6366C137.616 9.78039 142.227 4.7312 148.107 4.7312L152.942 4.7312C158.643 4.7312 163.19 9.49008 162.931 15.1853L162.482 25.0718C162.3 29.0773 159 32.2312 154.99 32.2312L146.506 32.2312C142.627 32.2312 139.388 29.2733 139.037 25.4102L138.148 15.6366Z"
        fill="#0A1935"
      />
      <path
        d="M156.79 17.0728L159.459 24.6712C159.551 24.9341 159.483 25.2268 159.284 25.422L157.635 27.0398L155.486 34.8734L155.871 43.1571C155.904 43.8638 155.544 44.5307 154.934 44.89L154.39 45.2108C151.632 46.8372 148.243 46.9723 145.364 45.5706L144.933 45.3605C144.305 45.0548 143.894 44.4306 143.862 43.7331L142.95 24.129L156.79 17.0728Z"
        fill="#F9B8A4"
      />
      <mask
        id="mask5_3099_21241"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="139"
        y="29"
        width="18"
        height="18"
      >
        <path
          d="M142.527 29.172L155.47 34.5541L156.019 46.3505L139.92 34.6735L142.527 29.172Z"
          fill="#F9B8A4"
        />
      </mask>
      <g mask="url(#mask5_3099_21241)">
        <path
          d="M156.518 40.5558C156.614 39.9508 155.193 37.6038 156.35 36.9394L147.115 36.028C146.673 35.9844 146.318 36.39 146.465 36.8091C148.483 42.5833 156.416 41.1972 156.518 40.5558Z"
          fill="#DB8C74"
        />
      </g>
      <path
        d="M139.159 25.3414C139.503 32.7232 143.486 38.9043 150.821 38.8799C157.559 38.8575 162.384 31.6587 162.04 24.277C153.399 18.2983 161.29 10.4755 151.166 10.5092C139.736 10.5472 147.151 17.0831 139.159 25.3414Z"
        fill="#0A1935"
      />
      <path
        d="M139.126 22.0943C139.451 29.0896 143.42 34.9381 150.754 34.8972C157.49 34.8595 162.332 28.0251 162.007 21.0299C161.681 14.0347 161.29 7.95124 151.167 8.00779C139.738 8.07163 138.801 15.0991 139.126 22.0943Z"
        fill="#F9B8A4"
      />
      <path
        d="M147.159 29.7307L153.409 29.7307C153.409 31.1114 152.29 32.2307 150.909 32.2307L149.659 32.2307C148.278 32.2307 147.159 31.1114 147.159 29.7307Z"
        fill="white"
      />
      <path
        d="M145.909 35.9807L144.778 30.3288C144.717 30.0194 144.953 29.7307 145.269 29.7307L150.284 29.7307L155.299 29.7307C155.614 29.7307 155.851 30.0194 155.789 30.3288L154.659 35.9807"
        stroke="#0A1935"
        strokeWidth="2.5"
        strokeLinecap="round"
        fill="transparent"
      />
      <path
        d="M140.228 17.2234C138.825 17.2092 137.933 15.7156 138.586 14.4732L141.534 8.86623C142.538 6.95548 145.233 6.84473 146.391 8.66661C147.115 9.80589 146.926 11.2992 145.942 12.2226L140.88 16.9696C140.703 17.135 140.47 17.2259 140.228 17.2234Z"
        fill="#0A1935"
      />
      <path
        d="M161.26 15.8291C162.902 14.9946 163.109 12.7313 161.645 11.6134L155.907 7.23149L152.362 5.88446C149.719 4.88057 146.745 6.02508 145.458 8.54112C144.586 10.2439 145.327 12.329 147.077 13.1003L154.297 16.2812C156.356 17.1882 158.713 17.1232 160.719 16.1041L161.26 15.8291Z"
        fill="#0A1935"
      />
      <path
        d="M163.375 24.8716C163.518 23.7529 162.646 22.7629 161.519 22.7629L139.509 22.7629C138.381 22.7629 137.51 23.7529 137.653 24.8716L137.925 27.0075C138.044 27.9421 138.84 28.6423 139.782 28.6423L161.246 28.6423C162.188 28.6423 162.984 27.9421 163.103 27.0075L163.375 24.8716Z"
        fill="#F9B8A4"
      />
      <path
        d="M150.39 24.2588L149.459 26.8349C149.241 27.4395 149.67 28.0828 150.312 28.1126L151.641 28.1744"
        stroke="#DB8C74"
        strokeWidth="0.763514"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="transparent"
      />
      <path
        d="M142.014 21.9344C141.591 20.8205 143.623 19.5169 145.595 19.1373C146.323 18.9973 146.954 19.5429 147.101 20.2693C147.144 20.4834 146.966 20.6811 146.748 20.6913C144.951 20.7747 142.129 22.2377 142.014 21.9344Z"
        fill="#081A3D"
      />
      <path
        d="M158.854 21.489C159.242 20.3627 157.172 19.1214 155.189 18.8018C154.457 18.6839 153.844 19.2484 153.719 19.979C153.682 20.1943 153.866 20.3865 154.084 20.39C155.883 20.4189 158.748 21.7955 158.854 21.489Z"
        fill="#081A3D"
      />
      <path
        d="M140.714 46.2987C139.748 45.5605 139.453 44.2349 140.015 43.157L142.832 37.7526C142.86 37.6976 142.939 37.6977 142.968 37.7528L143.221 38.2412C144.806 41.2962 147.124 43.9106 149.967 45.8503C150.083 45.9295 150.14 46.0709 150.111 46.2085L148.953 51.6967C148.877 52.0563 148.452 52.214 148.16 51.9907L140.714 46.2987Z"
        fill="#010E24"
      />
      <path
        d="M158.397 46.2987C159.363 45.5605 159.657 44.2349 159.096 43.157L156.282 37.7588C156.252 37.7012 156.17 37.7013 156.14 37.7589L155.816 38.383C154.277 41.349 152.058 43.9084 149.34 45.8516C149.229 45.9307 149.174 46.0666 149.198 46.2006L150.177 51.6649C150.243 52.0333 150.675 52.2013 150.972 51.974L158.397 46.2987Z"
        fill="#010E24"
      />
      <ellipse cx="145.596" cy="24.731" rx="0.9375" ry="1.25" fill="#0A1935" />
      <ellipse cx="155.596" cy="24.731" rx="0.9375" ry="1.25" fill="#0A1935" />
      <path
        d="M140.283 51.2935C140.283 51.4987 140.243 51.7019 140.165 51.8914C140.086 52.081 139.971 52.2533 139.826 52.3984C139.681 52.5434 139.508 52.6585 139.319 52.7371C139.129 52.8156 138.926 52.856 138.721 52.856C138.516 52.856 138.313 52.8156 138.123 52.7371C137.933 52.6585 137.761 52.5434 137.616 52.3984C137.471 52.2533 137.356 52.081 137.277 51.8914C137.199 51.7019 137.158 51.4987 137.158 51.2935L138.721 51.2935H140.283Z"
        fill="white"
      />
      <path
        d="M137.94 53.9497C137.94 53.8471 137.96 53.7455 137.999 53.6507C138.038 53.5559 138.096 53.4698 138.169 53.3973C138.241 53.3247 138.327 53.2672 138.422 53.2279C138.517 53.1886 138.618 53.1684 138.721 53.1684C138.824 53.1684 138.925 53.1886 139.02 53.2279C139.115 53.2672 139.201 53.3247 139.273 53.3973C139.346 53.4698 139.403 53.5559 139.443 53.6507C139.482 53.7455 139.502 53.8471 139.502 53.9497L138.721 53.9497L137.94 53.9497Z"
        fill="white"
      />
      <circle cx="154.658" cy="8.48096" r="5" fill="#0A1935" />
      <circle cx="149.658" cy="7.23096" r="5" fill="#0A1935" />
      <ellipse cx="142.158" cy="8.48096" rx="5" ry="3.75" fill="#0A1935" />
      <ellipse cx="158.408" cy="8.48096" rx="5" ry="3.75" fill="#0A1935" />
      <ellipse cx="150.283" cy="32.856" rx="1.25" ry="0.625" fill="#0A1935" />
    </g>
  </Icon>
);

export default TopEducators;
